import { render, staticRenderFns } from "./AllocationRecord.vue?vue&type=template&id=595af400&scoped=true&"
import script from "./AllocationRecord.vue?vue&type=script&lang=js&"
export * from "./AllocationRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595af400",
  null
  
)

export default component.exports